// Filename: models/questionnaire/questionnaire.js
define('models/payment/team-payment',[
    'underscore',
    'backbone',
    // services
    'services/api',
], function(
    _, Backbone, API
) {

    var MTeamPayment = Backbone.Epoxy.Model.extend({
        idAttribute: 'id',
        url: API.url("payments/team/"),

        getName: function() {
            return this.get('name');
        },

        getType: function() {
            return this.get('type');
        },

        getDueDate: function() {
            return this.get('dueDate');
        },

        getDueAmount: function() {
            return this.get('dueAmount') / 100;
        },

        getDetails: function() {
            return this.get('details');
        },

        getMembershipPlan: function() {
            return this.get('membershipPlan');
        },

        setMembershipPlan: function(planId) {
            return this.set({
                membershipPlan: planId
            });
        },

        getTaxRate: function() {
            return this.get('tax_rate');
        },

        getTaxAmount: function() {
            return this.get('tax_amount') / 100;
        },

        getCurrency: function() {
            return this.get('currency');
        },

        hasPayment: function() {
            return this.get('payment') !== false && this.get('payment') !== null;
        },

        deletePayment: function() {
            this.set({
                payment: null
            });
        }
    });

    // Return the model for the module
    return MTeamPayment;
});

